import React from 'react';
import LeftSideBarItem from "./LeftSideBarItem";
import { trans } from '../utils';

const LeftSideBarParentItem = ({ Toggle, setNavigate, MenuItem, activeSideBar, MenuItemKey, active, User }) => {
    const ChildArray = MenuItem.child;
    // Function to filter out items based on User.role
    const shouldShowItem = (moduleObj, user) => {
        if (!user || !user.role) {
            return false; // Ensure user data is valid
        }
        
        const { role } = user;
    
        if (role === 34) {
            // For role 34, remove specific items
            return !["CreateAssetItem", "Assign Asset Item", "RoomSpaceItem"].includes(moduleObj.name_en);
        }
    
        if (role === 2) {
            // For role 2, remove "MyAsset"
            return moduleObj.name_en !== "MyAsset";
        }
    
        // For all other roles, show the item
        return true;
    };

    return (
        <div
            onClick={(e) => {
                e.stopPropagation();
                activeSideBar(MenuItem.id);
            }}
            className={"menu-item menu-accordion " + active[MenuItem.id]}
        >
            <span className="menu-link">
                <span className="menu-icon">
                    <i className={MenuItem.icon}></i>
                </span>
                <span className="menu-title">{trans(MenuItem.parent_name_en)}</span>
                <span className="menu-arrow"></span>
            </span>

            <div className="menu-sub menu-sub-accordion menu-active-bg" kt-hidden-height="306">
                {MenuItem.menu === "show" && shouldShowItem(MenuItem, User) && (
                    <LeftSideBarItem MenuItem={MenuItem} />
                )}

                {ChildArray &&
                    ChildArray.map((SubMenuItem, SubMenuItemKey) => {
                        if (Array.isArray(SubMenuItem.child)) {
                            return (
                                <LeftSideBarParentItem
                                    key={SubMenuItemKey}
                                    MenuItem={SubMenuItem}
                                    activeSideBar={activeSideBar}
                                    MenuItemKey={SubMenuItemKey}
                                    active={active}
                                    User={User}
                                />
                            );
                        } else {
                            return (
                                SubMenuItem.menu === "show" &&
                                shouldShowItem(SubMenuItem, User) && (
                                    <LeftSideBarItem MenuItem={SubMenuItem} key={SubMenuItemKey} />
                                )
                            );
                        }
                    })}
            </div>
        </div>
    );
};

export default LeftSideBarParentItem;